<template>
  <div class="seomain">
		<st-header
		  :title="modeTitle + '销售出库'"
		  :back-able="true"
			:more-op="[{val: 'openShowSearch', title: '搜索' }, { val: 'startbatch', title: '批量处理' }]"
			@command="headercommand"
		>
		  <template slot="header-right">
				<!-- <span class="search-icon-span">
					<van-icon name="search" @click="showSearch = true"/>
				</span> -->
		  </template>
		</st-header>
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

   
    <div class="tab-content tab-content-list">
			<!-- 搜索 多行 -->
			<div class="keyword">
        <div class="keyword-panel" v-if="showSearch">
          <div class="keyword-panel-head">
            <span class="keyword-panel-title">搜索筛选</span>
            <span class="keyword-panel-close" @click="showSearch = false">
              <van-icon name="cross" />
            </span>
          </div>
			    <van-form class="keyword-form" @submit="submitKeyword">
			      <van-field v-model="searchData.order_code" label="单号" placeholder="请输入单号" />
			      <van-field v-model="searchData.sku" label="SKU" placeholder="SKU" />
			      <div class="keyword-form-actions">
			        <van-button round block type="info" native-type="submit">搜 索</van-button>
			      </div>
			    </van-form>
        </div>
        <div class="keyword-collapsed" v-else @click="showSearch = true">
          <van-icon name="search" />
          <span>搜索单号 / SKU</span>
        </div>
			</div>
			
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
            <router-link :to="'/saleo/info/' + v.id" class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
              <div class="t-status">待出库</div>
            </router-link>
            <div class="st-list-main"
							@touchstart="touchstart"
							@touchmove="touchmove"
							@touchend="touchend"
							@click="checkItem(v.id)"
						>
							<div class="list-checkbox" v-if="touchLong">
								<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
								<van-checkbox :value="checkList[v.id]"></van-checkbox>
							</div>
              <p>批次号：{{ v.batch }}</p>
              <p v-if="v.type == '销售订单'">
                订单类型：<span :style="{ color: '#ca151e' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '租赁订单'">
                订单类型：<span :style="{ color: '#ff5733' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '海外订单'">
                订单类型：<span :style="{ color: '#00baad' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '寄售订单'">
                订单类型：<span :style="{ color: '#2a82e4' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '投资订单'">
                订单类型：<span :style="{ color: '#f39c11' }">{{ v.type }}</span>
              </p>
              <p>包装类型：{{ v.packagetype }}</p>
              <p>销售商务：{{ v.seller_name }}</p>
              <p>
                销售电话：<a :href="'tel:' + v.seller_phone">{{ v.seller_phone }}</a>
              </p>
              <p>收货人：{{ v.receiver }}</p>
              <p>
                收货电话：<a :href="'tel:' + v.phone">{{ v.phone }}</a>
              </p>
              <p>收货地址：{{ v.adress }}</p>
            </div>
            <!-- <div class="st-list-bottom">
                        <router-link :to="'/saleo/info/'+v.id" class="st-opt-btn">出 库</router-link>
                        <router-link to="/saleo" class="st-opt-btn">出 库</router-link>
                    </div> -->
            <div class="st-list-bottom-diy" style="display: flex;justify-content: space-between;">
              <div class="st-diyr-btn">
                <div class="st-opt-btn" @click="goOutOrSend(v)">
                  {{ canSendAction(v) ? '发 货' : '出 库' }}
                </div>
              </div>
						<!-- 	<div class="st-diyr-btn">
							  <div class="st-opt-btn" @click="goUrl('/saleo/send/' + v.id)">
							    发 货
							  </div>
							</div> -->
							<div class="st-diyr-btn" style="background-color: rgb(229 134 19);">
							  <div class="st-opt-btn" @click="goUrl('/saleo/detail/' + v.id)">
							    查看详情
							  </div>
							</div>
            </div>
						<!-- <div class="st-list-bottom-diy" style="display: flex;justify-content: space-between;padding-top: 12px;">
							<div class="st-diyr-btn st-diyr-btn-6" style="background-color: rgb(82 145 246);">
							  <div class="st-opt-btn" @click="goUrl('/saleo/outlog/' + v.id)">
							    出库记录
							  </div>
							</div>
							<div class="st-diyr-btn st-diyr-btn-6" style="background-color: #857b7b;">
							  <div class="st-opt-btn" @click="goUrl('/saleo/sendlog/' + v.id)">
							    发货记录
							  </div>
							</div>
						</div> -->
					
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
              <div class="t-status">待签收</div>
            </div>
            <div class="st-list-main">
              <p>批次号：{{ v.batch }}</p>
              <p v-if="v.type == '销售订单'">
                订单类型：<span :style="{ color: '#ca151e' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '租赁订单'">
                订单类型：<span :style="{ color: '#ff5733' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '海外订单'">
                订单类型：<span :style="{ color: '#00baad' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '寄售订单'">
                订单类型：<span :style="{ color: '#2a82e4' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '投资订单'">
                订单类型：<span :style="{ color: '#f39c11' }">{{ v.type }}</span>
              </p>
              <p>包装类型：{{ v.packagetype }}</p>
              <p>销售商务：{{ v.seller_name }}</p>
              <p>
                销售电话：<a :href="'tel:' + v.seller_phone">{{ v.seller_phone }}</a>
              </p>
              <p>物流公司：{{ v.logisticser }}</p>
              <p @click="getExInfo(v.id, v.type)">物流单号：{{ v.courier }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
              <p>收货人：{{ v.receiver }}</p>
              <p>
                收货电话：<a :href="'tel:' + v.phone">{{ v.phone }}</a>
              </p>
              <p>收货地址：{{ v.adress }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyr-btn">
                <div class="st-opt-btn" @click="goSendAction(v)">
                  {{ hasPendingSend(v) ? '发 货' : '发货记录' }}
                </div>
              </div>
              <div class="st-diyr-btn" style="background-color: rgb(229 134 19);">
                <div class="st-opt-btn" @click="goUrl('/saleo/detail/' + v.id)">
                  查看详情
                </div>
              </div>
              <div class="st-diyr-btn" v-if="v.type === '海外订单'">
                <div class="st-opt-btn" @click="showUpdataDialogHandle(v.id)">更新物流信息</div>
              </div>
            </div>
						<!-- <div class="st-list-bottom-diy" style="display: flex;justify-content: space-between;padding-top: 12px;">
							<div class="st-diyr-btn st-diyr-btn-6" style="background-color: rgb(82 145 246);">
							  <div class="st-opt-btn" @click="goUrl('/saleo/outlog/' + v.id)">
							    出库记录
							  </div>
							</div>
							<div class="st-diyr-btn st-diyr-btn-6" style="background-color: #857b7b;">
							  <div class="st-opt-btn" @click="goUrl('/saleo/sendlog/' + v.id)">
							    发货记录
							  </div>
							</div>
						</div> -->
            <!-- <div class="st-list-bottom">
              <router-link :to="'/saleo/info/' + v.id" class="st-opt-btn">查 看</router-link>
            </div> -->
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
              <div class="t-status">已入库</div>
            </div>
            <div class="st-list-main">
              <p>批次号：{{ v.batch }}</p>
              <p v-if="v.type == '销售订单'">
                订单类型：<span :style="{ color: '#ca151e' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '租赁订单'">
                订单类型：<span :style="{ color: '#ff5733' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '海外订单'">
                订单类型：<span :style="{ color: '#00baad' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '寄售订单'">
                订单类型：<span :style="{ color: '#2a82e4' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '投资订单'">
                订单类型：<span :style="{ color: '#f39c11' }">{{ v.type }}</span>
              </p>
              <p>包装类型：{{ v.packagetype }}</p>
              <p>销售商务：{{ v.seller_name }}</p>
              <p>
                销售电话：<a :href="'tel:' + v.seller_phone">{{ v.seller_phone }}</a>
              </p>
              <p>物流公司：{{ v.logisticser }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.courier }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
              <p>收货人：{{ v.receiver }}</p>
              <p>
                收货电话：<a :href="'tel:' + v.phone">{{ v.phone }}</a>
              </p>
              <p>收货地址：{{ v.adress }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/saleo/info/' + v.id" class="st-opt-btn">查 看</router-link>
              </div>
              <div class="st-diyr-btn" v-if="v.type === '海外订单'">
                <div class="st-opt-btn" @click="showUpdataDialogHandle(v.id)">更新物流信息</div>
              </div>
            </div>
						<!-- <div class="st-list-bottom-diy" style="display: flex;justify-content: space-between;padding-top: 12px;">
							<div class="st-diyr-btn st-diyr-btn-6" style="background-color: rgb(82 145 246);">
							  <div class="st-opt-btn" @click="goUrl('/saleo/outlog/' + v.id)">
							    出库记录
							  </div>
							</div>
							<div class="st-diyr-btn st-diyr-btn-6" style="background-color: #857b7b;">
							  <div class="st-opt-btn" @click="goUrl('/saleo/sendlog/' + v.id)">
							    发货记录
							  </div>
							</div>
						</div> -->
          </div>
					</van-list>
      </div>
			
			
			<batch-btn
				v-if="touchLong"
				:options="batchBtnOptions[cur]"
				@command="batchCommand"
			></batch-btn>
		</div>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>

    <van-dialog
      class="exDialog"
      ref="exDialog"
      v-model="updataExShow"
      title="更新物流信息"
      confirmButtonText="提交"
      @confirm="editExpress"
      showCancelButton
    >
      <van-field v-model="updataExMsg" rows="2" autosize type="textarea" placeholder="请输入信息" />
    </van-dialog>
		
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import BatchBtn from "@/components/layout/BatchBtn.vue";
export default {
  components: {
		"st-header": StHeader,
		'batch-btn': BatchBtn,
	},
  props: {},
  data() {
    return {
			batchBtnOptions: [
				[
					{ text: '操作', children: [
							{ text: '销售合同', value: 'geneSalesContract' },
						],
					}
				],
				[],
				[],
			],
			pdfshow: true,
			showSearch: false,
			searchData: {
				order_code: "",
				sku: "",
			},
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["待出库", "待发货", "已签收"],
      cur: 0,
      status: 0,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      exShow: false,
      exDialogTitle: "",
      exDataList: [],
      updataExShow: false, // 更新物流信息对话框的标识 (海外)
      updataExMsg: "",
      updataActiveId: 0,
			touchLong: false,
			touchTimeOut: null,
			checkList: {},
      mode: "",
    };
  },
  watch: {
		touchLong: function(nv, ov) {
			this.checkList = {};
			this.$forceUpdate();
		}
	},
  methods: {
    resetPageInteraction() {
      this.touchLong = false;
      clearTimeout(this.touchTimeOut);
      this.touchTimeOut = null;
      document.body.style.overflow = "auto";
      if (this.$toast && typeof this.$toast.clear === "function") {
        this.$toast.clear();
      }
    },
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      this.mode = this.$route.query.type === "1" ? "1" : "0";
      let activeIndex = window.sessionStorage.getItem("saleo_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
			this.touchLong = false;
      window.sessionStorage.setItem("saleo_activeIndex", value);
    },
    // 分页
    async onLoad() {
			let params = this.searchData;
			params['status'] = this.cur;
			params['page'] = this.page;
      params['type'] = this.mode;
      let result = await this.$post(this.$api.stGetXiaoshouoList, params);

      if (!result.data.list || result.data.list.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 质检
    async changQualityStatus(inspect, id) {
      console.log(arguments);
      inspect = Number.parseInt(inspect);
      let result;
      switch (inspect) {
        case 0:
          // 质检操作
          result = await this.$post(this.$api.stGetXiaoshouCheck, { id });
          if (result.code == 200) {
            this.$toast.success("质检成功!");
            this.stlist0 = this.stlist0.filter((item) => {
              if (item.id == id) {
                item.inspect = 1;
              }
              return item;
            });
          }
          break;
        case 1:
          // 提交审批
          this.$toast.loading({
            message: "审批提交中...",
            forbidClick: true,
            loadingType: "spinner",
          });

          try {
            result = await this.$post(this.$api.stOutApprove, { id });
            this.stlist0 = this.stlist0.filter((item) => {
              if (item.id == id) {
                item.inspect = 2;
              }
              return item;
            });
            return this.$toast.success("已提交审批!");
          } catch (error) {
            his.$toast.fail("提交失败!");
          }

          break;
        case 2:
          this.stlist0 = this.stlist0.filter((item) => {
            if (item.id == id) {
              item.inspect = 3;
            }
            return item;
          });
          return this.$toast.fail("审批中");
          break;
        case 3:
          return this.$toast("审批已通过");
          break;
      }
      // if (inspect == 1) {
      //   this.$toast.fail("已质检");
      //   return;
      // }
    },
    goUrl(url) {
      const isSaleoRoute = typeof url === "string" && url.indexOf("/saleo/") === 0;
      if (isSaleoRoute) {
        const hasQuery = url.indexOf("?") >= 0;
        const hasType = /(?:\?|&)type=/.test(url);
        if (!hasType) {
          url = `${url}${hasQuery ? "&" : "?"}type=${this.mode}`;
        }
      }
      this.$router.push(url);
      return;
    },
    canSendAction(item) {
      const row = item || {};
      const status = String(row.status || "");
      const statusText = String(row.status_text || row.send_status || "");
      const toSend = Number(row.to_send || 0);

      // 与PC口径保持一致：有可发货数量时可直接发货；否则按状态兜底
      return toSend > 0 || status === "5" || status === "18" || statusText === "待发货" || statusText === "出库审批通过";
    },
    hasPendingSend(item) {
      return Number((item && item.to_send) || 0) > 0;
    },
    goOutOrSend(item) {
      if (this.canSendAction(item)) {
        this.goUrl(`/saleo/send/${item.id}`);
      } else {
        this.goUrl(`/saleo/out/${item.id}`);
      }
    },
    goSendAction(item) {
      if (this.hasPendingSend(item)) {
        this.goUrl(`/saleo/send/${item.id}`);
      } else {
        this.goUrl(`/saleo/sendlogdetail/${item.id}`);
      }
    },
    // 获取物流信息
    async getExInfo(id, type) {
      if (type === "海外订单") console.log("type:海外订单");
      let { logisticser, courier } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      if (courier == null || courier.trim() == "") return;

      this.exDialogTitle = logisticser + ": " + courier;
      let result = await this.$post(this.$api.stGetXiaoshouExInfo, { id });
      if (result.data.code == 1) {
        console.log(result.data.data);
        this.exDataList = result.data.data;
      } else {
        this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
      }
      this.exShow = true;
    },
    // 打开更新物流信息对话框
    showUpdataDialogHandle(id) {
      this.updataActiveId = id;
      this.updataExShow = true;
      this.updataExMsg = "";
    },
    // 更新物流信息(海外)
    async editExpress() {
      let result = await this.$post(this.$api.stUpdataExInfo, { id: this.updataActiveId, msg: this.updataExMsg });
      if (result.code == 200) {
        this.$toast.success("更新成功");
        let list = this["stlist" + this.cur].filter((item) => {
          console.log(item.id, this.updataActiveId, this.updataExMsg);
          if (item.id == this.updataActiveId) {
            item.logistics_status = this.updataExMsg;
          }
          return item;
        });
        console.log(list);
        this["stlist" + this.cur] = list;
        console.log(this["stlist" + this.cur]);
        this.updataExShow = false;
      }
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
		// 开始触屏
		touchstart() {
			this.touchTimeOut = setTimeout(() => {
				this.touchLong = true;
			}, 2500)
		},
		touchmove() {
			clearTimeout(this.touchTimeOut);
		},
		touchend() {
			clearTimeout(this.touchTimeOut);
		},
		
		// #region-start 批量操作相关方法
		// 勾选
		checkItem(id) {
			this.checkList[id] = !this.checkList[id];
			this.$forceUpdate();
		},
		getCheckIds() {
			let ids = [];
			for (let i in this.checkList) {
				if (this.checkList[i]) {
					ids.push(i);
				}
			}
			
			return ids;
		},
		headercommand(val) {
			this[val]();
		},
		openShowSearch() {
			this.showSearch = true;
		},
		/**
		 * 下载采购单
		 */
		download() {
			let params = this.searchData;
			params['status'] = this.cur;
      params['type'] = this.mode;
			
			let tempArray = [];
			for (const item in params) {
				if (params[item] !== undefined && item) {
					tempArray.push(`${item}=${params[item]}`);
				}
			}
			// let url = `${this.$api.stPurchaseDownload}?${tempArray.join('&')}`;
			// window.open(url);
		},
		
		// 开启批量模式
		startbatch() {
			this.touchLong = true;
		},
		
		batchCommand(sign, params) {
			if (sign == 'cancel') {
				this.touchLong = false;
				return;
			}
			
			let checkedIds = this.getCheckIds();

			// 生成销售合同
			if (sign == 'geneSalesContract') {
				this.$post(this.$api.stSaleGeneContract, {ids: checkedIds}).then((res) => {
					// let route = "/pdf/" + encodeURIComponent(res.data);
					// this.goUrl(route);
					window.location = res.data;
				}).catch((err) => {
					console.log(err)
				});
			}
		},
		// #region-edn 批量操作相关方法
	},
  computed: {
    modeTitle() {
      return this.mode === "1" ? "HK" : "SZ";
    },
  },
  created() {
    this.resetPageInteraction();
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "销售出库" });
    });
  },
  mounted() {
    this.resetPageInteraction();
  },
  beforeDestroy() {
    this.resetPageInteraction();
  },
};
</script>
<style lang="scss" scoped>
div {
	box-sizing: border-box;
}
.search-icon-span .van-icon {
	font-size: 24px!important;
	color: #1a89fa;
	margin: 8px 12px;
	font-weight: 900;
}
.keyword {
  position: relative;
	top: 0;
  width: 100%;
  z-index: 1;
  background-color: transparent;
  padding-top: 0;
  padding-bottom: 8px;
  margin-top: 66px;
  margin-bottom: 0;
}

.keyword-panel {
  margin: 0 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eceff5;
  overflow: hidden;
}

.keyword-panel-head {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f2f7;
}

.keyword-panel-title {
  font-size: 14px;
  color: #5c6575;
  font-weight: 600;
}

.keyword-panel-close {
  color: #8a93a3;
  font-size: 18px;
  line-height: 1;
}

.keyword-form {
  margin: 0;
}

.keyword-form-actions {
  padding: 12px;
  background-color: #fff;
}

.keyword-collapsed {
  margin: 0 12px;
  height: 40px;
  border-radius: 10px;
  background: #fff;
  color: #8b95a7;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: none;
  border: 1px solid #eceff5;
}
/* 2行input start */
.tab-content-list {
  padding-top: 0;
	position: relative;
	top: 0;
	
	.st-list {
		margin: 12px 24px;
		border-radius: 5px;
	}
}

::v-deep .van-list__finished-text {
  padding-top: 12px;
}

.tab-tilte {
  display: flex;
  overflow-x: hidden;
  height: 62px;
  min-height: 62px;
  align-items: center;
  padding: 2px 0 4px;
  box-sizing: border-box;
}

.tab-tilte .text-center {
  flex: 1 1 0;
  min-width: 0;
  height: 100%;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-tilte .text-center span {
  font-size: 14px;
  line-height: 1;
}

.tab-tilte .active span {
  display: block;
  margin: 0 4px;
  padding: 10px 10px;
  border-radius: 999px;
}

/* 2行input  end */

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
}
.st-list-bottom-diy .st-diyl-btn.active {
  background: #677588;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #3c8dbc;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
.st-list-bottom-diy .st-diyr-btn:first-child {
	margin-left: 0px;
}
.st-diyl-btn.checkBy {
  background-color: #677588;
}
.st-list-main {
	position: relative;
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}

</style>

<style scoped>
	.st-diyr-btn-6 {
		width: 45%;
	}
</style>
